
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import util from './../../utils/utils';
import intl from 'react-intl-universal';
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const UPDATE_FORM_VALUE = "UPDATE_FORM_VALUE";
export const GET_NETWORK = "GET_NETWORK";

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

export function updateFormValue(values, type) {
  return (dispatch, getState) => {
    const { noQRcodeValue, APValue } = getState().network;
    dispatch({
      type: UPDATE_FORM_VALUE,
      noQRcodeValue: type === "noQRcode" ? Object.assign({}, noQRcodeValue, values)  : {},
      APValue: type === "AP" ? Object.assign({}, APValue, values)  : {}
    });
  };
}
/**
 * 配网信息修改
 * @param {*} values 
 */
export function addNetwork(values) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { firmwareUpgradeCode, productId  } = currentProductInfo;
    const defaultParam = {
      pId: productId,
      firmwareUpgradeCode: firmwareUpgradeCode
    };
    const req = Object.assign({}, defaultParam, values);
    message.loading("loading...", 0);
    const fetchData = new FetchData(`/iot/config/api/iot/support/updateNetWorkText`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(data => {
        message.destroy()
        if (data.code == 200) {
          message.success(intl.get('home.product.feature.saveSuccess'));
        } else {
          message.error(intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.destroy()
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

/**
 * 获取配网信息
 * @param {*} values 
 * @param {*} type 
 */
export function getNetwork(values, type) {
  return (dispatch, getState) => {
    const currentProductInfo = JSON.parse(util.getStorage('ezviz_iot_current_product_info'));
    const { firmwareUpgradeCode, productId  } = currentProductInfo;
    const defaultParam = {
      pId: productId,
      firmwareUpgradeCode: firmwareUpgradeCode,
    };
    const req = Object.assign({}, defaultParam, values);
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`/iot/config/api/iot/support/getNetWorkText`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(data => {
        dispatch(updateLoadingStatus(false));
        if (data.code == 200) {
          let networkInfo = {};
          if(Object.keys(data).length !== 0) {
            for (let [key, value] of Object.entries(data.data)) {
              if (key.indexOf("T") > -1 && value.length > 0) {
                value.forEach(item => {
                  if (item.languageType === "zh_CN") {
                    networkInfo[key + "_zh"] = item.translationText;
                  } else {
                    networkInfo[key + "_en"] = item.translationText;
                  }
                });
              }
              if (key.indexOf("P") > -1) networkInfo[key] = value;
            }
          }
          dispatch({
            type: UPDATE_FORM_VALUE,
            noQRcodeValue: type === "noQRcode" ? networkInfo : {},
            APValue: type === "AP" ? networkInfo : {}
          });
        } else {
          dispatch({
            type: UPDATE_FORM_VALUE,
            noQRcodeValue: {},
            APValue: {}
          });
        }
      })
      .catch(e => {
        dispatch({
          type: UPDATE_FORM_VALUE,
          noQRcodeValue: {},
          APValue: {}
        });
        dispatch(updateLoadingStatus(false));
      });
  };
}
